import { aboutContent } from '../../data/landing-content'

export default function AboutStats() {
  return (
    <div className="mt-12 max-w-[640px]">
      <h2 className="text-[clamp(2rem,2.8vw+1rem,2.8rem)] tracking-[-0.03em] font-bold m-0 mb-4">
        {aboutContent.title}
      </h2>
      <p className="text-ink-soft leading-relaxed m-0">
        {aboutContent.description}
      </p>
    </div>
  )
}
